var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-box forth",style:({ backgroundColor: `${_vm.config.bg}` })},[_c('div',{staticClass:"hero-section-swiper-box"},[_c('img',{staticClass:"hero-img",attrs:{"src":_vm.config.cover,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }